// extracted by mini-css-extract-plugin
export default {"barChartWrapper":"barGraph_barChartWrapper__SuGGo","toLeft":"barGraph_toLeft__rNPqW","progress":"barGraph_progress__ojMhh","toRight":"barGraph_toRight__6oA4Z"};